/**
 * Случайный идентификатор (не для секретов). `crypto.randomUUID` есть только в безопасном контексте
 * (`docs/open_questions.md`, «HTTPS»), поэтому без него — 16 случайных байт из `crypto.getRandomValues`.
 */
export function randomId(): string {
    const { crypto } = globalThis;
    if (typeof crypto?.randomUUID === "function") return crypto.randomUUID();

    const bytes = new Uint8Array(16);
    if (typeof crypto?.getRandomValues === "function") {
        crypto.getRandomValues(bytes);
    } else {
        for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

/** UUID в каноническом виде в нижнем регистре (`xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx`, только `0-9a-f`). */
export const isCanonicalUuid = (value: string) => UUID_PATTERN.test(value);

/**
 * UUID v4 в каноническом виде в нижнем регистре: `crypto.randomUUID` в безопасном контексте, иначе 16 байт из
 * `crypto.getRandomValues` (он есть и без HTTPS) с битами версии и варианта.
 */
export function randomUuid(): string {
    const { crypto } = globalThis;
    if (typeof crypto?.randomUUID === "function") return crypto.randomUUID().toLowerCase();

    const bytes = new Uint8Array(16);
    if (typeof crypto?.getRandomValues === "function") {
        crypto.getRandomValues(bytes);
    } else {
        for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6]! & 0x0f) | 0x40;
    bytes[8] = (bytes[8]! & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
